import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchMe,
  clearEnableTotp,
  clearDeleteTotp,
} from 'redux/users/actions';

import Button from 'components/elements/buttons/Button';
import TwoFactorAuthenticationModal
  from 'components/dashboard/security-content/TwoFactorAuthenticationModal';
import TwoFactorDisconnectModal
  from 'components/dashboard/security-content/TwoFactorDisconnectModal';

import './TwoFactorAuthentication.css';

function TwoFactorAuthentication(props) {
  const {
    me,
    fetchMe,
    clearEnableTotp,
    clearDeleteTotp,
    enableTotpSuccess,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      clearEnableTotp();
      clearDeleteTotp();
    };
  }, []);

  const onAuthModalClose = () => {
    setModalOpen(false);
    if (enableTotpSuccess) {
      clearEnableTotp();
      setTimeout(() => {
        fetchMe();
      }, 500);
    }
    clearDeleteTotp();
  };

  return (
    <div className="two-factor-authentication__component">
      <div className="wrapper">
        <div className="label">{t("Two Factor Authentication")}</div>
        <Button
          small
          disabled={me.is_2fa_enabled}
          onClick={() => setModalOpen(true) }
        >
          {me.is_2fa_enabled &&
            <div className="icon" />
          }
          {me.is_2fa_enabled ? t("Enabled") : t("Enable")}
        </Button>
      </div>
      <div className="undertext">
        {me.is_2fa_enabled ?
          <div>
            {t("We'll ask for a verification code via your security " +
               "method if we notice a login from an unrecognized device or browser.")}
          </div>
          :
          <div>{t("Enable two-factor authentication in order to protect your account")}</div>
        }
      </div>
      {me.is_2fa_enabled &&
        <div className="buttons-block">
          <Button
            small
            borderedBlue
            onClick={() => setDisconnectModalOpen(true) }
          >
            {t("Turn Off")}
          </Button>
        </div>
      }

      {/* Two Factor Authentication Modal */}
      <TwoFactorAuthenticationModal
        open={modalOpen}
        onClose={onAuthModalClose}
      />

      {/* Two Factor Disconnect Modal */}
      <TwoFactorDisconnectModal
        open={disconnectModalOpen}
        onClose={() => {
          setDisconnectModalOpen(false);
        }}
      />
    </div>
  );
}

TwoFactorAuthentication.propTypes = {
  fetchMe: PropTypes.func.isRequired,
  clearEnableTotp: PropTypes.func.isRequired,
  clearDeleteTotp: PropTypes.func.isRequired,
  me: PropTypes.object,
  enableTotpSuccess: PropTypes.object,
};

TwoFactorAuthentication.defaultProps = {
  me: null,
  enableTotpSuccess: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    enableTotpSuccess: state.usersReducer.enableTotpSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    clearEnableTotp,
    clearDeleteTotp,
  },
)(TwoFactorAuthentication);
